<template>
  <div class="v3-popup title-popup">
    <div
      class="v3-popup-mask"
      @click="v3PopupState.titlePopupState = false"
    ></div>
    <div class="v3-popup-content succ">
      <div
        class="v3-popup-content-close"
        @click="v3PopupState.titlePopupState = false"
      ></div>

      <template v-if="lotteryAndTaskState.titlePopup.title !== '無'">
        <div class="v3-popup-content-title"></div>
      </template>
      <div
        class="v3-popup-content-content"
        :style="lotteryAndTaskState.titlePopup.title !== '無' ? `color: ${lotteryAndTaskState.titlePopup.color}` : ''"
      >
        {{ lotteryAndTaskState.titlePopup.title }}
      </div>
      <div class="v3-popup-content-footer">
        <div
          class="confirm-btn btns"
          @click="v3PopupState.titlePopupState = false"
        >{{ langData.confirmBtn }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";
import LanguageHook from "@hooks/language";

const { langData } = LanguageHook();

const v3PopupState = inject("v3PopupState");
const lotteryAndTaskState = inject("lotteryAndTaskState");
</script>
